import { Card, CardSection, Col, Paragraph, Row, SmallText } from 'hui';
import { Tag } from 'hui.icons';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ArticleRoute from '../Articles/SingleArticle/Route';
import { formatDate } from './utils';
import Wrap from './Wrap';

const FullRow = styled(Row)`
  width: 100%;
`;
const ImageContainer = styled.div`
  height: 130px;
  width: 100%;
  border-radius: ${props => props.theme.radius.container};
  overflow: hidden;
`;
const ImageLink = styled(Link)`
  width: 100%;
  height: 100%;
  display: inline-block;
  background-position: 50%;
  background-size: cover;
`;
const TagIcon = styled(Tag)`
  position: relative;
  top: 2px;
  margin-right: 0.5rem;
  fill: ${props => props.theme.colors.tint2};
`;

const Bold = styled.b`
  font-weight: bold;
`;

const ArticleList = ({ articles, keywords = '' }) => {
  const matchers = !keywords.length
    ? []
    : keywords.split(' ').map(keyword => ({
        test: new RegExp(keyword, 'gi'),
        transform: token => <Bold>{token}</Bold> // eslint-disable-line
      }));

  return (
    <Card pt={0} pb={0}>
      {articles.map(article => (
        <CardSection
          pt={1}
          pb={1}
          key={article.id}
          style={{ display: 'flex' }}
          onMouseOver={() => ArticleRoute.preload()}
        >
          <FullRow>
            <Col xs={12} md={3}>
              <ImageContainer>
                <ImageLink
                  to={`/article/${article.key}`}
                  style={{ backgroundImage: `url("${article.heroTile}")` }}
                />
              </ImageContainer>
            </Col>
            <Col xs={12} md={9}>
              <Link to={`/article/${article.key}`}>
                <Paragraph bold mt={{ xs: 1, md: 0 }} mb={0} as="h4" color="primary">
                  {article.title}
                </Paragraph>
              </Link>
              <SmallText color="tint2">
                {formatDate(article.lastModified)} · {article.author}
              </SmallText>
              <Wrap matchers={matchers}>{article.summary}</Wrap>
              <Paragraph />
              <SmallText color="tint2">
                {article.topicKey && (
                  <Fragment>
                    <Link to={`/c/${article.topicKey}`}>
                      <TagIcon />
                      <Paragraph color="primary" as="span">
                        {article.topicName}
                      </Paragraph>
                    </Link>
                    <span> · </span>
                  </Fragment>
                )}
                <span>{Math.ceil(article.readingTime)} min read</span>
              </SmallText>
            </Col>
          </FullRow>
        </CardSection>
      ))}
    </Card>
  );
};

ArticleList.propTypes = {
  articles: PropTypes.array,
  keywords: PropTypes.string
};

export default ArticleList;
